/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { View, Button } from '@adobe/react-spectrum';
import { Heading, NoTaskDiv, NoTaskText } from './style';

import TaskCard from './TaskCard';

const TaskColumn = ({ items, type, title }) => {
  const [count, setCount] = useState(3);

  const onPress = () => {
    setCount(count + 3);
  };
  return (
    <View gridArea={type}>
      {title === 'In-Review' ? (
        <Heading>Complete({items && items.length})</Heading>
      ) : (
        <Heading>
          {title}({items && items.length})
        </Heading>
      )}
      {items && items.length > 0 ? (
        items
          .slice(0, count)
          .map(row => (
            <TaskCard
              key={row.ID + new Date().getTime()}
              type={`card-${type}`}
              data={row}
            />
          ))
      ) : (
        <NoTaskDiv>
          {title === 'Backlog' ? (
            <NoTaskText>{`No Task in ${title}`}</NoTaskText>
          ) : title === 'In-Progress' ? (
            <NoTaskText>{`No Task ${title}`}</NoTaskText>
          ) : (
            <NoTaskText>{`No Task Complete
            `}</NoTaskText>
          )}
        </NoTaskDiv>
      )}
      {items && items.length > 3 && items.length !== count ? (
        <Button marginTop="size-300" variant="cta" onPress={onPress}>
          Show More
        </Button>
      ) : null}
    </View>
  );
};

TaskColumn.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string,
    }),
  ),
  type: PropTypes.string,
  title: PropTypes.string,
};

TaskColumn.defaultProps = {
  type: '',
  title: '',
  items: [],
};

export default TaskColumn;
